import { makeZeroArgHook } from "../../utils/makeZeroArgHook";
import { BlockId, getStagedOrders, OrderSide, OrderType, PQSAssetClass, PQSClientOrderId, StagedOrder, url, } from "../request/getStagedOrders";
export { PQSClientOrderId, BlockId, OrderType, OrderSide, PQSAssetClass, StagedOrder, };
export function keyMaker() {
    return [url()];
}
const useStagedOrders = makeZeroArgHook(getStagedOrders, keyMaker);
export default useStagedOrders;
//# sourceMappingURL=useStagedOrders.js.map